/** Canonical backend codes — clients.profile_metadata.business_scale */

export const BUSINESS_SCALE_OPTIONS = [
  { value: 'MIKRO', label: 'Mikro' },
  { value: 'KECIL', label: 'Kecil' },
  { value: 'MENENGAH', label: 'Menengah' },
  { value: 'BESAR', label: 'Besar' },
];
